import { Spin } from "components/ui/spin/Spin"
import style from "./CustomChatIndexingInProgress.module.scss"

const { customChatIndexingInProgress } = style

type Props = { text: string }

export const CustomChatIndexingInProgress = ({ text }: Props) => {
	return (
		<div className={customChatIndexingInProgress}>
			<Spin color="#CCCAD1" />
			{text}
		</div>
	)
}
